import Vue from 'vue';
import { LoadingService } from '@/services/index';
import { EventBus } from '@/event-bus/index';
import { getContentArea } from '@/contentful/index';

export default Vue.extend({
  methods: {
    openRegisterScreen(params): void {
      LoadingService.watchPromises(getContentArea([
        'register-success',
        'register-error-default',
        'register-error-already-registered',
        'register-error-username-in-use',
        'register-blocked',
        'password-rules',
      ])).then((data) => {
        const CONTENT_AREAS = data[0];
        let paramsObj: any = {};
        if (CONTENT_AREAS) {
          if (CONTENT_AREAS[0] && CONTENT_AREAS[0].fields) {
            paramsObj.successMessage = CONTENT_AREAS[0].fields.content;
          }
          if (CONTENT_AREAS[1] && CONTENT_AREAS[1].fields) {
            paramsObj.errorMessage = CONTENT_AREAS[1].fields.content;
          }
          if (CONTENT_AREAS[2] && CONTENT_AREAS[2].fields) {
            paramsObj.errorMessageAlreadyRegistered = CONTENT_AREAS[2].fields.content;
          }
          if (CONTENT_AREAS[3] && CONTENT_AREAS[3].fields) {
            paramsObj.errorMessageUsernameInUse = CONTENT_AREAS[3].fields.content;
          }
          if (CONTENT_AREAS[4] && CONTENT_AREAS[4].fields) {
            paramsObj.errorMessageBlocked = CONTENT_AREAS[4].fields.content;
          }
          if (CONTENT_AREAS[5] && CONTENT_AREAS[5].fields) {
            paramsObj.passwordRules = CONTENT_AREAS[5].fields.content;
          }
        }
        paramsObj = Object.assign(paramsObj, params);
        EventBus.$emit('openOverlayWrapper', 'Register', paramsObj);
      }).catch(() => {
        EventBus.$emit('openModal', 'Error', {
          message: 'global_connection-error',
        });
      });
    },
  },
});

